import { FunctionComponent } from 'react';
import { Link } from 'dibs-elements/exports/Link';

import styles from './styles/CheckoutPaymentStepCreditCardOption.scss';
import { FormattedMessage } from 'dibs-react-intl';

type CheckoutPaymentStepCreditCardOptionProps = {
    token: string;
    cardLogo: string;
    cardType: string;
    formattedTextMaskedCardNumber: string;
    cardExpiryMonth: string;
    cardExpiryYear: string;
    onDelete: () => void;
};

export const CheckoutPaymentStepCreditCardOption: FunctionComponent<
    CheckoutPaymentStepCreditCardOptionProps
> = props => {
    const {
        cardLogo,
        cardType,
        formattedTextMaskedCardNumber,
        cardExpiryMonth,
        cardExpiryYear,
        onDelete,
    } = props;
    return (
        <div className={styles.option}>
            {cardLogo && <img className={styles.logo} src={cardLogo} alt={cardType} />}
            <div className={styles.details}>
                <div className={styles.importantDetails}>{formattedTextMaskedCardNumber}</div>
                <div>
                    {cardExpiryMonth}/{cardExpiryYear}
                </div>
            </div>
            <div>
                <Link onClick={onDelete}>
                    <FormattedMessage
                        id="checkout.CheckoutPaymentStepCreditCardOption.delete_action"
                        defaultMessage="Delete"
                    />
                </Link>
            </div>
        </div>
    );
};
